const round = (n, precision = 0) => {
    const precisionConst = Math.pow(10, precision);
    return Math.round(n * precisionConst) / precisionConst;
};

const formatFilesize = (filesize) => {
    const parsedFilesize = Number(filesize);
    if (isNaN(parsedFilesize)) return null;
    if (parsedFilesize === 0) return "0 KB";

    const units = ["KB", "MB", "GB", "TB"];
    const unitIndex = Math.floor(round(Math.log(parsedFilesize) / Math.log(1024), 1));

    return unitIndex > 0 ? `${round(parsedFilesize / Math.pow(1024, unitIndex), 2)} ${units[unitIndex]}` : `${parsedFilesize} KB`;
};

export default formatFilesize;
